// secondaryReportService.js - Service for fetching Secondary Stage HPC Report data

import { getAccessToken } from '../../../authClient';
import { API_CONFIG } from '../../../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

/**
 * Fetch Secondary Stage HPC Report data for the current student
 */
export const fetchSecondaryStageHPCReportForStudent = async () => {
    try {
        const token = getAccessToken();
        if (!token) {
            throw new Error('Authentication required');
        }

        const response = await fetch(`${API_BASE_URL}/secondary/user/student/hpc-report`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error('Authentication required');
            } else if (response.status === 403) {
                throw new Error('Access denied - Secondary stage students only');
            } else if (response.status === 404) {
                throw new Error('Student profile not found');
            } else if (response.status >= 500) {
                throw new Error('Server error - Please try again later');
            } else {
                throw new Error(`Failed to fetch report data: ${response.status}`);
            }
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching secondary stage HPC report:', error);
        throw error;
    }
};

/**
 * Fetch profile picture for the current student
 */
export const fetchProfilePicture = async () => {
    try {
        const token = getAccessToken();
        if (!token) {
            return null;
        }

        const response = await fetch(`${API_BASE_URL}/user/profile-picture`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        }

        return null;
    } catch (error) {
        console.error('Error fetching profile picture:', error);
        return null;
    }
};

/**
 * Format date for display in reports
 */
export const displayDate = (dateString) => {
    if (!dateString) return '';

    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
};

/**
 * Get user stage information
 */
export const getUserStage = async () => {
    try {
        const token = getAccessToken();
        if (!token) {
            throw new Error('Authentication required');
        }

        const response = await fetch(`${API_BASE_URL}/user/stage`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch user stage: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching user stage:', error);
        throw error;
    }
};